/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: '首頁',
	homePageTabsLabel: '首頁內容',
	myContent: '我的內容',
	teamContent: '團隊內容',
	folder: '資料夾',
	files: '檔案',
	actionMenu: '動作功能表',
	myFolder: '我的資料夾',

	emptyFolderNoContent: '無內容',

	//EmptyStates
	emptyRecentTitle: '您最近尚未檢視過任何內容。',
	emptyStateTitle: '透過新增資料來開始',
	emptyStateBody: '按一下上述的上傳資料或拖放以上傳資料。',
	emptySearchResultTitle: '嗯，您的搜尋沒有返回任何結果。',
	emptyPortalTitle: '無入口網站',
	emptyPortalBody: '您目前沒有任何入口網站。',
	emptyWsProjectTitle: '透過在 Watson Studio 中建立記事本來開始。',
	emptyWsProjectBody: '返回 Cognos Analytics 時，您的記事本將會出現在這裡。',
	emptyFilteredResultTitle: '嗯，套用的過濾器沒有返回任何結果。',
	emptyDialogViewTitle: '無項目',
	removeFromRecents: '從最新移除',

	// Welcome Banner
	welcomeBannerGreeting: '您好， 歡迎使用 Cognos Analytics with Watson。',
	welcomeBannerDescription: 'Cognos Analytics with Watson 可讓使用者擁有 AI 驅動的自助式分析功能。 請參閱「自動化資料準備、資料探索和視覺化可以驅動更多機密決策的方法」。',
	welcomeBannerDescription_trialUser: '您可以透過瀏覽我們的簡介影片、產品導覽和「開始使用」標籤來立即開始。',
	takeTourButtonLabel: '接受產品導覽',
	watchVideoButtonLabel: '觀看影片',
	// confirmation dialog
	hideWelcomeBannerMsg: '您確定要從您的首頁關閉歡迎使用橫幅嗎？您可以隨時在「設定檔」（設定 > 設定 > 一般）中回復開啟此歡迎使用橫幅。',
	hideWelcomeBannerTitle: '關閉歡迎使用橫幅',
	ok: '確定',
	cancel: '取消',
	warn: '警告',
	//howto video dialog
	modal_how_title: '觀看 Cognos Analytics 概觀',
	modal_overview_title: '觀看 Cognos Analytics 概觀',
	modal_how_play: '播放影片',
	modal_how_video_title_overview: '概觀',
	modal_how_video_title_getStarted: '在 11.2 中開始使用',
	modal_how_video_title_newUI: '歡迎使用新的 Cognos 體驗',
	modal_how_video_title_dataModule: '資料模組概觀',
	modal_how_video_title_explore: '資料探索概觀',
	modal_how_video_title_dashboard: '互動式儀表板概觀',
	modal_how_video_title_reporting: '報告概觀',
	modal_how_video_title_mobile: 'Cognos 的能力一切盡在掌握中',

	// Toolbar
	search: '搜尋',
	addFolder: '新增資料夾',
	addLink: '新增鏈結',
	filter: '過濾',
	sort: '排序',
	settings: '設定',
	tilesView: '並排視圖',
	listView: '清單視圖',
	columnView: '直欄視圖',
	backToSearch: '回到搜尋結果',

	// Toolbar Actions
	sortBy: '排序方式',
	sortOrder: '順序',
	name: '名稱',
	modifiedTime: '已修改',
	type: '類型',
	ascending: '遞增',
	descending: '遞減',
	resetSort: '重設排序',

	filterType: '類型',
	filterModificationTime: '已修改',
	all: '全部',
	today: '今天',
	yesterday: '昨天',
	pastWeek: '上週',
	pastMonth: '上個月',
	resetFilters: '重設過濾器',
	resultLimit: '結果限制',

	filterSearchPlaceHolder: '依關鍵字過濾',

	resetFilterTag: '按一下 X 以重設過濾器。',
	filterTagToolTip: '已套用的過濾器：%{appliedFilters}。',

	folderName: '資料夾名稱',
	addAFolder: '新增資料夾',
	add: '新增',
	error: '錯誤',
	newFolderDefaultName: '新資料夾',
	toastCreateNewFolder: '%{nameOfFolder} 資料夾已在 %{tabName} 中建立。',
	folderAdded: '資料夾已新增',
	refresh: '重新整理',
	openFolder: '開啟資料夾',

	addAUrl: '新增 URL',
	linkName: 'URL 名稱',
	linkNamePlaceholder: '新增 URL 名稱',
	linkDescription: '說明（選用）',
	linkDescriptionPlaceholder: '新增說明',
	linkUri: 'URL',
	linkUriPlaceholder: '新增含可接受的網域的 URL',
	acceptableDomains: '可接受的網域',
	viewAcceptableDomains: '檢視可接受的網域',
	mandatoryField: '必要欄位',
	linkAdded: 'URL 已新增',
	toastCreateNewLink: '%{nameOfLink} 已新增至 %{tabName}。',
	noEntries: '在可接受的網域清單中沒有任何項目。請聯絡您的管理者。',
	unacceptableDomain: '您的 URL 使用無效的網域。 按一下「檢視可接受的網域」，以查看您可以使用的網域清單。',

	compact: '壓縮',
	short: '短',
	default: '預設',
	rowSize: '列大小',

	// GroupyByTypes
	folders: '資料夾',
	reports: '報告',
	dashboards: '儀表板',
	data: '資料',
	packages: '套件',
	explorations: '探索',
	stories: '案例',
	notebooks: '記事本',
	others: '其他',

	// Error Messages
	itemsOverLimit: '指定的名稱 "%{itemName}" 已超過上限 (20)。請指定其他名稱以繼續進行。',
	errorMessageLengthFolderName: '請輸入資料夾名稱，且不可超過 255 個字元。',
	errorMessageLengthLinkName: '請輸入不超過 255 個字元的鏈結名稱。',
	toastLaunchPerspectiveError: '無法開啟 %{objectType}。',
	errorNoAccessTitle: '嗯，您似乎沒有此內容的存取權',
	errorNoAccessBody: '請聯絡管理者或請參閱下列鏈結：',
	errorEnableExternalContent: '啟用外部內容',

	//TableHeader
	lastAccessed: '前次存取',
	location: '位置',
	tenant: '租戶',

	// GetStartedTab
	getStartedLabel: '開始進行 IBM Cognos Analytics',
	learningHowToLabel: '學習資源',
	learningHowToDescription: '透過與社群進行連線、閱讀文件和觀看影片來擴展您的知識並取得協助。',
	learningHowToActionLabel: '啟動學習窗格',
	howToVideosLabel: '指引影片',
	howToVideosDescription: '學習如何使用 IBM Cognos Analytics 並開始獲得對資料的見解。',
	howToVideosActionLabel: '觀看影片',
	acceleratorCatalogLabel: '加速器型錄',
	acceleratorCatalogDescription: '瀏覽產業用途、最佳作法手冊、自訂視覺化以及其他的增長型錄。',
	acceleratorCatalogActionLabel: '瀏覽型錄',
	sampleSectionTitle: '範例',
	sampleSectionDescription: '炫耀 Cognos Analytics 必須提供的所有功能的範例實驗。',
	// Samples Section
	createDashboardSampleTitle: '如何建立您的第一個儀表板',
	createDashboardSampleDescription: '使用 Cognos Dashboard 來開始您的分析旅程。',
	nlaSampleTitle: '範例報告',
	nlaSampleDescription: '利用範例分析年終會員卡成員活動，探索 Cognos Analytics Report 的可行性。',
	sankeySampleTitle: '桑基圖',
	sankeySampleDescription: '使用自訂視覺化（如桑基圖）來擴展您的視覺化檔案庫。',
	viewAllSamplesActionLabel: '檢視所有範例',
	byFeatureTitle: '依特性',
	byFeatureDescription: '依特性（例如，核心功能、自訂控制項、延伸項目、記事本和相對日期）來瀏覽範例。',
	byIndustryTitle: '依產業',
	byIndustryDescription: '依產業（例如，汽車業、銀行業和其他）來瀏覽範例。',
	// SamplesTab
	sampleTabTitle: '從我們預先建置的範例中得到靈感',
	sampleTabLabel: '造訪加速器型錄以從 IBM、夥伴和客戶得到更多範例和延伸',

	// quickLaunch
	quickLaunchLabel: '快速啟動',
	expand: '展開',
	collapse: '收合',

	// quickLaunch dialog
	quickLaunchModalLabel: '藉由選擇您要建立的項目來開始。',

	// contentPageView
	contentPageTitleLabel: '內容',
	uploadFile: '上傳資料',
	new: '新建',
	create: '建立',
	more: '其他',

	// open dialog
	selectDataSourcesToAdd: '選取要新增的資料來源。',
	openDialogDefaultTitle: '開啟',

	// save dialog
	save: '儲存',
	saveAs: '另存新檔',
	saving: '儲存中...',
	selectedDestination: '選取的目的地：%{nameOfFolder}',
	toastDuplicateFileDifferentType: '具有其他類型的 \'%{nameOfItem}\' 已存在。請選擇不同的名稱。',
	confirmOverwriteTitle: '確認取代現有資料',
	confirmOverwriteMsg: '檔案 \'%{nameOfFile}\' 已存在。您要將其資料取代為所選取檔案中所含的資料嗎？',

	// copy move dialog
	copy: '複製',
	move: '移動',
	copyOrMove: '複製或移動： ',
	copyOnly: '複製',
	createShortcut: '建立捷徑',
	createShortcutDialogTitle: '建立捷徑：',

	// External asset types
	wsProject: 'Watson Studio 專案',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: '套件',
	dataModule: '資料模組',
	exploration: '探索',
	mode: '模式',
	live: '即時',
	snapshot: 'Snapshot',
	noSnapshotsFound: '找不到 Snapshot',
	uploadedFile: '上傳的檔案',
	fileUpload: '上傳資料',
	dataSetEx: '資料集',
	externalRepository: '外部儲存庫',
	queryMode: '查詢模式',
	queryModeCompatible: '相容',
	queryModeDynamic: '動態',
	report: '報告',
	activeReport: '作用中報告',
	query: '查詢',
	analysis: '分析',
	dashboard: '儀表板',
	dashboardTemplate: '儀表板範本',
	jupyterNotebook: '記事本',
	wsNotebook: 'Watson Studio 記事本',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: '案例',
	workspace: '工作區',
	pagelet: '頁面',
	content: '內容',
	directory: '名稱空間',
	dataSet: '資料集',
	powerPlayCube: 'PowerPlay Cube',
	powerPlayReport: 'PowerPlay 報告',
	powerPlay8Report: 'PowerPlay 報告',
	setPowerPlay8ReportOptions: '設定 PowerPlay 報告選項',
	powerPlay8ReportView: 'PowerPlay 報告視圖',
	reportTemplate: '報告範本',
	packageConfigurations: '套件配置',
	agent: '代理程式',
	agentDefinition: '代理程式定義',
	agentDefinitionView: '代理程式視圖',
	dataMovementTask: '資料移動作業',
	dataMovementTaskAlias: '資料移動作業別名',
	document: '文件',
	DocumentRetention: '文件內容',
	jobDefinition: '工作定義',
	job: '工作',
	jobs: '工作',
	metricsDataSourceETLTask: '計量資料來源 ETL 作業',
	metricsExportTask: '計量資料匯出作業',
	metricsFileImportTask: '計量資料檔案匯入作業',
	metricsMaintenanceTask: '計量資料維護作業',
	planningTask: '規劃作業',
	shortcut: '捷徑',
	shortcuts: '捷徑',
	URL: 'URL',
	launchable: '可啟動',
	dataSetFolder: '資料集資料夾',
	ViewAccessibleLabel: '視圖 %{label}',
	overrideReportOptions: '置換預設報告選項',
	formats: '格式',
	saveReport: '儲存報告',
	reportView: '報告視圖',
	reportviews: '報告視圖',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel 資料',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: '角色',
	namespace: '名稱空間',
	namespaceFolder: '名稱空間資料夾',
	adminFolder: '管理資料夾',
	//Details
	details: '詳細資料',
	open: '開啟',
	created: '建立時間',
	modified: '已修改',
	owner: '擁有者',
	dataSource: '資料來源',
	share: '共用',
	addToFavorites: '加到我的最愛',
	properties: '內容',
	detailsEmptyStateBody: '選取項目以檢視它的詳細資料',
	editNameAndDescription: '編輯名稱和說明',
	none: '無',
	setPdfOptions: '設定 PDF 選項',
	runOptions: '執行選項',

	//rename dialog
	nameInvalid: '名稱無效',
	namePlaceholder: '輸入名稱',
	description: '說明',
	descriptionInvalid: '說明不得超過 350 個字元。',
	descriptionPlaceholder: '輸入說明',
	errorMessageApostropheError: '請輸入不包含 \' 與 " 字元的檔名',
	renameCollisionError: '%{name} 已存在。請嘗試不同的名稱。',
	unknownRenameError: '項目重新命名失敗。請聯絡您的管理者以取得進一步的協助。',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: '無法開啟指定的資料夾。',

	//Upload
	uploadToFolder: "上傳至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "上傳至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> 並啟動 %{launchAction}",
	quickUpload: "快速上傳",
	quickUploadAndLaunch: "拖放檔案以上傳至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> 並在其中一個下列空間中開啟。",
	unsupportedFilesSingle: "%{files} 未上傳，因為它對「快速啟動」無效。",
	unsupportedFilesMultiple: "未上傳檔案，因為您選取的所有檔案都必須有效，才能使用「快速啟動」。",
	unsupportedFilesSingleInvalid: "%{files} 無效。",
	unsupportedFilesMultipleInvalid: "%{files} 無效。",
	supportedFileTypes: "僅接受下列檔案類型：%{extensions}。",
	uploadDragAndDrop: "拖放",
	uploadDragAndDropMessage: "在這裡拖放您的檔案以將它上傳至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: '搜尋準則 \'%{searchTerm}\' 已儲存。',
	searchWasntSaved: '搜尋準則 \'%{searchTerm}\' 未儲存。',
	searchSuggestions: '建議',
	savedSearch: '已儲存的搜尋',
	searchWasDeleted: '搜尋準則 \'%{searchTerm}\' 已刪除。',
	searchWasntDeleted: '搜尋準則 \'%{searchTerm}\' 未刪除。',
	savedBarTitle: '搜尋 Cognos Analytics',
	searchContentPageTitle: '搜尋',
	searchContentPageTitleLabel: '顯示 \'%{searchTerm}\' 的結果',
	showingSearchRsult: '顯示 %{resultCount} 項目',
	saveSearch: '儲存搜尋',
	saveTenSearches: '您可以儲存 10 個搜尋。',
	deleteASearch: '刪除一個以儲存另一個。',
	close: '關閉',
	allContent: '所有內容',
	searchResultIn: '搜尋結果位置： ',
	//recent view
	recents: '最近',
	noAccessRecent: '無法存取',
	noAccessRecentMsg: '您沒有此資產的存取權。它可能已停用或已刪除，或者您的許可權可能已減少。請驗證資產在預期的來源位置上的狀態。您可以透過按一下「確定」，從最近的項目中刪除資產。',
	noAccessMsg: '您沒有此資產的存取權。它可能已停用或已刪除，或者您的許可權可能已減少。',

	//contextToolbar
	itemsSelected: '已選取 %{nameOfSelection} 個項目',
	itemSelected: '已選取 %{nameOfSelection} 個項目',

	//properties
	general: '一般',
	schedule: '排程',
	permission: '許可權',
	capabilities: '功能',
	propertiesTabsLabel: '屬性內容',
	searchPath: '搜尋路徑',
	id: 'ID',
	language: '語言',
	setLanguage: '設定語言',
	entryOptions: '項目選項',
	setPackage: '設定套件或模組',
	sourcePackage: '來源套件或資料模組',
	associatedSourceAgent: '來源套件',
	setAssociatedSourceAgent: '設定套件',
	sourceAgent: '來源代理程式',
	setSourceAgent: '設定來源代理程式',
	setCapabilities: '設定功能',
	disableEntry: '停用此項目',
	hideEntry: '隱藏此項目',
	permissions: '許可權',
	promptForValues: '提示輸入值',
	yes: '是',
	no: '否',
	setValues: '設定值',
	moreOptions: '更多選項',
	reportFormat: '報告格式',
	enableAccessibilitySupport: '啟用協助工具支援',
	displayOfRunHistory: '顯示執行歷程',
	occurrences: '出現項目數',
	days: '天數',
	months: '月',
	displayOfReportOutputVersions: '顯示報告輸出版本',
	defaultDisplayOfPortalAction: '預設入口網站動作',
	viewMostRecentReport: '檢視最新報告',
	runTheReport: '執行報告',
	openWithReportStudio: '使用 Report Studio 開啟',
	rowsPerPageInHtmlReports: 'HTML 報告中每頁的列數',
	enableSelectionBasedInteractivity: '啟用選項型互動功能',
	enableAlertsAboutNewVersions: '啟用關於新版本的警示',
	enableEnhancedUserFeaturesInSavedOutputVersions: '在已儲存的輸出版本中啟用加強型使用者特性',
	enableCommentsInSavedOutputVersions: '在已儲存的輸出版本中啟用註解',
	run: '執行',
	runWithUsersCredentials: '使用使用者的認證',
	runWithOwnerCapabilities: '使用擁有者功能',
	runAsOwner: '以 %{ownerName} 身分',
	actionLabelOn: '開啟',
	actionLabelOff: '關閉',
	openReport: '編輯',
	openAnalysis: '使用 Analysis Studio 開啟',
	openQuery: '使用 Query Studio 開啟',
	openPowerPlay8Report: '使用 PowerPlay Studio 進行開啟',
	openInteractiveReport: '編輯',
	read: '讀取',
	write: '寫入',
	execute: '執行',
	setPolicy: '設定原則',
	full: '完整',
	traverse: '遍訪',
	grant: '授與',
	deny: '拒絕',
	permissionCustom: '自訂',
	permissionDetailsColumnAccess: '存取',
	permissionDetailsColumnPermission: '權限',
	permissionDetailsColumnAction: '動作',
	permissionSetAccess: '設定存取權',
	permissionRead: '讀取',
	permissionRun: '執行',
	permissionWrite: '寫入',
	permissionFull: '完整',
	unavailable: '無法使用',
	unkownSource: '不明，請開啟報告以取得詳細資料',
	tenantSettings: '租戶設定',
	tenantSet: '租戶已更新',
	tenantSetError: '設定租戶時發生錯誤',
	tenantClear: '租戶已清除',
	tenantClearError: '清除租戶時發生錯誤',
	shortcutTo: '下列項目的捷徑：',
	sourceReport: '來源報告',
	setSourceReport: '設定來源報告',
	setSourceLocation: '設定來源 %{itemName} 位置',
	linkPackageOrModule: '將 %{itemName} 鏈結至套件或資料模組',
	linkPackage: '將 %{itemName} 鏈結至套件',
	externalRepositories: '外部儲存庫',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: '重新整理時間',
	size: '大小',
	tenantsWarningMessage: '變更某一項目的租戶也會變更子項目的租戶。',
	confirmClearTenantText: '如果清除「無」值，可能容許其他租戶存取內容。 按一下「確定」以讓此項目變成公開，或按一下「取消」以保留現行租戶。',
	confirmClearTenant: '確認清除租戶',
	currentValues: '現行值',
	emptyPromptValues: '目前沒有值',
	editValues: '編輯值',
	clear: '清除',
	source: '來源',
	dataRefreshed: '已重新整理資料',
	//PDF options
	pdfOptions: 'PDF 選項',
	set: '設定',
	portrait: '直印',
	landscape: '橫印',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: '方向',
	pageDefination: '紙張大小',
	openPasswordRequired: '需要密碼才能開啟報告',
	accessPasswordRequired: '需要密碼才能存取報告',
	emptyPassword: '密碼不得空白',
	password: '密碼',
	enterPassword: '輸入密碼',
	confirmPassword: '確認密碼',
	passwordMatchError: '密碼不符',
	gateway: '閘道',
	pageLayout: '頁面佈置',
	pageStyle: '樣式',
	setUrl: '設定 URL',
	numberRows: '列數',
	numberColumns: '欄數',
	timeToRefresh: '要重新整理的時間',
	lastRefreshedBy: '重新整理者',
	unknown: '不明',
	unknownUpdateError: '項目更新失敗。 請聯絡您的管理者以取得進一步的協助。',
	editQuery: '編輯查詢',
	greaterOrEqual: '大於或等於 %{upperboundValue}',
	lessOrEqual: '小於或等於 %{lowerboundValue}'
});
